import React from "react";
import styled from "styled-components";


export default styled.span`
    font-weight: 600;
    margin: 17px 20px 0;
    font-size: 14px;
    flex: 0 1 auto;
    height: 25px;
    padding-left: 35px;
    text-align: center;
    color: white;
    background: rgb(140 143 168);
    border-radius: 15px;
    text-transform: uppercase;
    opacity: ${(props) => (!!props.hidden ? "1" : "0")};
    box-sizing: border-box;

    @media(max-width: 1553px) {
        padding: 0;
    }

    @media(max-width: 1024px) {
        display: none;
    }
`;
